// Fecha de hoy en la zona del navegador, como YYYY-MM-DD.
//
// NO usar toISOString().slice(0,10): eso pasa a UTC, así que después de las
// 19:00 de Lima devuelve el día siguiente. Un campo de fecha que propone
// mañana hace que el backend rechace la carga con "la fecha no puede ser
// futura", y el usuario no entiende por qué.
export function hoyLocal() {
  const d = new Date();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${mm}-${dd}`;
}

// Igual que hoyLocal pero corrido n meses, para los rangos por defecto.
export function hoyLocalMenosMeses(n) {
  const d = new Date();
  d.setMonth(d.getMonth() - n);
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${mm}-${dd}`;
}
